export const NO_DRAW = -1;
export const GRAPHIC_LINE = 0;
export const GRAPHIC_ARROW = 1;
export const GRAPHIC_CIRCLE = 2;